'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { omit } from 'underscore';
import { FINDER_FILE_RENAME } from 'DesignData/actions/ActionTypes';
import { createPath, createPathFromFile } from 'DesignData/helpers/routingHelper';
import { FilePropTypes } from 'DesignData/propTypes/finder';
import { getFile } from 'DesignData/selectors/finder';
import AssetContextMenu from 'DesignFinderUI/components/menus/AssetContextMenu';
import FolderNavItemLink from 'DesignFinderUI/components/nav/FolderNavItemLink';
import RenameFileConfirmModal from 'DesignComponents/modals/RenameFileConfirmModal';

function mapStateToProps(state, props) {
  const file = getFile(state, props);
  let fileRoute = createPathFromFile(file);

  if (fileRoute == null) {
    fileRoute = createPath(file.designAssetType, file.id, {
      assetSource: file.assetSource
    });
  }

  return {
    fileRoute
  };
}

class FileTitle extends PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      isContextMenuOpen: false,
      showRenameConfirmModal: false,
      renameValue: null,
      contextMenuInitialized: false
    };

    this.handleRenameSubmit = renameValue => {
      const {
        isRenamingDuplicate,
        onRenameConfirm,
        showRenameConfirm
      } = this.props;

      if (isRenamingDuplicate || !showRenameConfirm) {
        onRenameConfirm(renameValue);
      } else {
        this.onRenameSubmit(renameValue);
      }
    };

    this.handleContextMenuOpenChange = isContextMenuOpen => {
      this.setState({
        isContextMenuOpen
      });
    };

    this.onRenameSubmit = renameValue => {
      this.setState({
        showRenameConfirmModal: true,
        renameValue
      });
    };

    this.handleRenameCallback = () => {
      this.props.toggleRenameFile();
      this.setState({
        showRenameConfirmModal: false,
        renameValue: null
      });
    };

    this.initializeContextMenu = () => {
      this.setState({
        contextMenuInitialized: true
      });
    };
  }

  renderRenameConfirmModal() {
    return /*#__PURE__*/_jsx(RenameFileConfirmModal, {
      callback: this.handleRenameCallback,
      fileId: this.props.fileId,
      newFileName: this.state.renameValue
    }, "RenameFileConfirmModal");
  }

  render() {
    const {
      className,
      fileName,
      filePermissions,
      isRenamingFile,
      pushRoute,
      fileRoute
    } = this.props;
    const {
      isContextMenuOpen,
      showRenameConfirmModal,
      contextMenuInitialized
    } = this.state;
    const {
      [FINDER_FILE_RENAME]: canRenameFile
    } = filePermissions;
    const renameConfirmModal = showRenameConfirmModal ? this.renderRenameConfirmModal() : null;
    const fileClasses = classNames('file-item-link', className, isContextMenuOpen && 'is--context-menu-open');

    let fileTitleNavLink = /*#__PURE__*/_jsx(FolderNavItemLink, Object.assign({}, this.props, {
      canRename: canRenameFile,
      className: fileClasses,
      extraChildren: [renameConfirmModal],
      isRenameActive: isRenamingFile,
      isRenameConfirmPending: showRenameConfirmModal,
      linkComponent: "div",
      name: fileName,
      onFocus: this.initializeContextMenu,
      onMouseEnter: this.initializeContextMenu,
      onRenameSubmit: this.handleRenameSubmit,
      to: fileRoute,
      pushRoute: pushRoute
    }));

    if (contextMenuInitialized) {
      fileTitleNavLink = /*#__PURE__*/_jsx(AssetContextMenu, Object.assign({}, omit(this.props, ['className']), {
        onOpenChange: this.handleContextMenuOpenChange,
        children: fileTitleNavLink
      }));
    }

    return fileTitleNavLink;
  }

}

FileTitle.propTypes = {
  className: PropTypes.string,
  fileId: FilePropTypes.fileId.isRequired,
  fileName: FilePropTypes.fileName.isRequired,
  filePermissions: FilePropTypes.filePermissions.isRequired,
  fileType: FilePropTypes.fileType.isRequired,
  fileRoute: PropTypes.string.isRequired,
  isRenamingDuplicate: PropTypes.bool.isRequired,
  isRenamingFile: FilePropTypes.isRenamingFile.isRequired,
  onRenameCancel: PropTypes.func.isRequired,
  onRenameConfirm: PropTypes.func.isRequired,
  showRenameConfirm: PropTypes.bool.isRequired,
  pushRoute: PropTypes.func.isRequired,
  toggleRenameFile: PropTypes.func.isRequired
};
FileTitle.defaultProps = {
  className: ''
};
export default connect(mapStateToProps)(FileTitle);